import { render, staticRenderFns } from "./PromoPizzaLegend.vue?vue&type=template&id=cae4e97a&lang=pug"
import script from "./PromoPizzaLegend.vue?vue&type=script&lang=js"
export * from "./PromoPizzaLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports